export default {
    name: 'settings',
    type: 'document',
    title: 'Page Settings',
    fields: [
        {
            name: 'title',
            type: 'string',
            title: 'Title',
            readOnly: true,
            hidden: true,
        },
        {
            name: 'slug',
            type: 'slug',
            title: 'Slug',
            readOnly: true,
            hidden: true,
        },
        {
            name: 'highlight',
            type: 'string',
            title: 'Highlight Colour',
        },
        {
            name: 'meta_title',
            type: 'string',
            title: 'Page Title',
        },
        {
            name: 'meta_description',
            type: 'string',
            title: 'Page Description',
        },
    ]
}


// WEBPACK FOOTER //
// ./schemas/settings.js